import { render } from "./slide4.vue?vue&type=template&id=104ffd82&scoped=true"
import script from "./slide4.vue?vue&type=script&lang=js"
export * from "./slide4.vue?vue&type=script&lang=js"

import "./slide4.vue?vue&type=style&index=0&id=104ffd82&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104ffd82"]])

export default __exports__